import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    getRecommendationIconByType,
    RecommendationСharacterWeight
} from '../../service/RecommendationsHelpers/RecommendationsHelpers';
import { banners, BasePopupProps, campaigns, groups } from '../../typings/common';
import { GridViewType } from '../../typings/grid';
import {
    ContextRecommendation,
    RecommendationKey,
    RecommendationsIconType,
    RecommendationType
} from '../../typings/recommendations';
import { ContainerOverflow } from '../ContainerOverflow/ContainerOverflow';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';
import { AddAdditionsItemCalloutsRecommendationCard } from '../RecommendationCard/AddAdditionsItemCalloutsRecommendationCard/AddAdditionsItemCalloutsRecommendationCard';
import { AddAppropriateCreativesRecommendationCard } from '../RecommendationCard/AddAppropriateCreativesRecommendationCard/AddAppropriateCreativesRecommendationCard';
import { AddAppropriatePlacementRecommendationCard } from '../RecommendationCard/AddAppropriatePlacementRecommendationCard/AddAppropriatePlacementRecommendationCard';
import { AddBannerDisplayHrefsRecommendationCard } from '../RecommendationCard/AddBannerDisplayHrefsRecommendationCard/AddBannerDisplayHrefsRecommendationCard';
import { AddBannerImageRecommendationCard } from '../RecommendationCard/AddBannerImageRecommendationCard/AddBannerImageRecommendationCard';
import { AddBillboardFormatsRecommendationCard } from '../RecommendationCard/AddBillboardFormatsRecommendationCard/AddBillboardFormatsRecommendationCard';
import { AddCreativesRecommendationCard } from '../RecommendationCard/AddCreativesRecommendationCard/AddCreativesRecommendationCard';
import { AddSiteLinksRecommendationCard } from '../RecommendationCard/AddSiteLinksRecommendationCard/AddSiteLinksRecommendationCard';
import { AddTitleExtensionRecommendationCard } from '../RecommendationCard/AddTitleExtensionRecommendationCard/AddTitleExtensionRecommendationCard';
import { BannerModerationRecommendationCard } from '../RecommendationCard/BannerModerationRecommendationCard/BannerModerationRecommendationCard';
import { CampaignDayBudgetRecommendationCardGridPopup } from '../RecommendationCard/CampaignDayBudgetRecommendationCardGridPopup/CampaignDayBudgetRecommendationCardGridPopup';
import { GroupModerationRecommendationCard } from '../RecommendationCard/GroupModerationRecommendationCard/GroupModerationRecommendationCard';
import { LowShowsRecommendationCard } from '../RecommendationCard/LowShowsRecommendationCard/LowShowsRecommendationCard';
import { RecommendationCardView } from '../RecommendationCard/RecommendationCard';
import { RemovePagesFromBlackListRecommendationCardGridPopup } from '../RecommendationCard/RemovePagesFromBlackListRecommendationCardGridPopup/RemovePagesFromBlackListRecommendationCardGridPopup';
import { SendLisencesRecommendationCard } from '../RecommendationCard/SendLisencesRecommendationCard/SendLisencesRecommendationCard';
import { SwitchOnAutotargetingRecommendationCardGridPopup } from '../RecommendationCard/SwitchOnAutoTargetingRecommendationCardGridPopup/SwitchOnAutoTargetingRecommendationCardGridPopup';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './RecommendationsTooltip.css';
import * as keyset from './RecommendationsTooltip.i18n';

const i18n = i18nFactory(keyset);

export interface RecommendationsTooltipBaseProps {
    view: GridViewType;
    cls?: string;
    recommendations?: Array<ContextRecommendation>;
    onSubmitRecommendation?: (type: RecommendationType, keys: Array<RecommendationKey>) => void;
    onShowRecommendation?: (view: RecommendationCardView, type: RecommendationType) => void;
    recommendationIconType: RecommendationsIconType;
}

interface RecommendationsTooltipCampaignProps extends RecommendationsTooltipBaseProps {
    view: campaigns;
}

interface RecommendationsTooltipBannerProps extends RecommendationsTooltipBaseProps {
    view: banners;
    onSendLicenseButtonClick?: () => void;
}

interface RecommendationsTooltipGroupProps extends RecommendationsTooltipBaseProps {
    view: groups;
}

export type RecommendationsTooltipProps =
    | RecommendationsTooltipCampaignProps
    | RecommendationsTooltipGroupProps
    | RecommendationsTooltipBannerProps;

export class RecommendationsTooltip extends React.PureComponent<RecommendationsTooltipProps & BasePopupProps> {
    private tooltipSwitcher: React.ReactNode | null;

    render() {
        const { recommendations = [], isPopupVisible, openPopup, recommendationIconType } = this.props;

        const iconTone = recommendationIconType === RecommendationsIconType.red ? Shape2Tone.red : Shape2Tone.yellow;

        return (
            <div className={classNames('recommendations-tooltip', this.props.cls)}>
                <span
                    className={Bem.cls({
                        block: 'recommendations-tooltip',
                        elem: 'btn',
                        mods: { active: isPopupVisible }
                    })}
                    onClick={openPopup}
                    ref={ref => (this.tooltipSwitcher = ref)}
                >
                    <Shape2
                        icon={Shape2Icon.lamp}
                        tone={iconTone}
                        width={12}
                        height={12}
                        cls={Bem.cls('recommendations-tooltip', 'btn-icon')}
                        title={i18n('icon-title')}
                    />

                    <span className={Bem.cls('recommendations-tooltip', 'items-number')}>{recommendations.length}</span>
                </span>

                {this.getPopup()}
            </div>
        );
    }

    private getPopup = () => {
        const { recommendations = [], isPopupVisible, closePopup } = this.props;

        return (
            <PopupDecorator
                cls={Bem.cls('recommendations-tooltip', 'popup')}
                onOutsideClick={closePopup}
                target={'anchor'}
                anchor={this.tooltipSwitcher}
                visible={isPopupVisible}
                directions={['right-center', 'top-left', 'left-center']}
                hasTail={true}
                header={i18n('popup-title')}
                hasClose={true}
                onClose={closePopup}
            >
                <div className={Bem.cls('recommendations-tooltip', 'cards')}>
                    <ContainerOverflow>
                        {recommendations
                            .sort(
                                (a, b) =>
                                    RecommendationСharacterWeight[a.character] -
                                    RecommendationСharacterWeight[b.character]
                            )
                            .map((recommendation, index) => {
                                return (
                                    <div key={index} className={Bem.cls('recommendations-tooltip', 'card')}>
                                        {this.getRecommendationCardByView(recommendation)}
                                    </div>
                                );
                            })}
                    </ContainerOverflow>
                </div>
            </PopupDecorator>
        );
    };

    private getRecommendationCardByView = (recommendation: ContextRecommendation) => {
        const { view } = this.props;

        switch (view) {
            case campaigns:
                return this.getCampaignRecommendationCard(recommendation);

            case banners:
                return this.getBannerRecommendationCard(recommendation);

            case groups:
                return this.getGroupRecommendationCard(recommendation);

            default:
                throw Error(`View ${view} не поддерживается в попапе рекомендаций`);
        }
    };

    private getGroupRecommendationCard = (recommendation: ContextRecommendation) => {
        if (this.props.view !== groups) {
            return null;
        }

        const recommendationCardView = RecommendationCardView.recommendationsPopup;

        switch (recommendation.type) {
            case RecommendationType.switchOnAutotargeting:
                return (
                    <SwitchOnAutotargetingRecommendationCardGridPopup
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        kpi={recommendation.kpi}
                        isApplicable={recommendation.isApplicable}
                        onAcceptClick={this.onSubmitRecommendation(recommendation.type, recommendation.keys)}
                        status={recommendation.status}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.changeAdGroupWithLowStat:
                return (
                    <LowShowsRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.changeAdGroupForModeration:
                return (
                    <GroupModerationRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.addBannerFormats:
                return (
                    <AddCreativesRecommendationCard
                        character={recommendation.character}
                        view={recommendationCardView}
                        formats={recommendation.kpi.formats}
                    />
                );

            case RecommendationType.chooseAppropriatePlacementsForAdGroup:
                return (
                    <AddBillboardFormatsRecommendationCard
                        type={RecommendationType.chooseAppropriatePlacementsForAdGroup}
                        character={recommendation.character}
                        view={recommendationCardView}
                        ratioInfoList={recommendation.kpi.ratioInfoList}
                    />
                );

            case RecommendationType.uploadAppropriateCreatives:
                return (
                    <AddAppropriateCreativesRecommendationCard
                        character={recommendation.character}
                        view={recommendationCardView}
                        videoFormats={recommendation.kpi.videoFormats}
                    />
                );
            default:
                return null;
        }
    };

    private getBannerRecommendationCard = (recommendation: ContextRecommendation) => {
        if (this.props.view !== banners) {
            return null;
        }

        const recommendationCardView = RecommendationCardView.recommendationsPopup;

        switch (recommendation.type) {
            case RecommendationType.sendLicenses:
                return (
                    <SendLisencesRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        theme={recommendation.theme}
                        onSendLicenseButtonClick={this.props.onSendLicenseButtonClick}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.changeBannerForModeration:
                return (
                    <BannerModerationRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.addBannerDisplayHrefs:
                return (
                    <AddBannerDisplayHrefsRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.addSiteLinks:
                return (
                    <AddSiteLinksRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.addTitleExtension:
                return (
                    <AddTitleExtensionRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.addAdditionsItemCallouts:
                return (
                    <AddAdditionsItemCalloutsRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.addImageToBanner:
                return (
                    <AddBannerImageRecommendationCard
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        view={recommendationCardView}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.chooseAppropriatePlacementsForBanner:
                return (
                    <AddAppropriatePlacementRecommendationCard
                        type={RecommendationType.chooseAppropriatePlacementsForBanner}
                        character={recommendation.character}
                        view={recommendationCardView}
                        videoFormats={recommendation.kpi.videoFormats}
                    />
                );

            default:
                return null;
        }
    };

    private getCampaignRecommendationCard = (recommendation: ContextRecommendation) => {
        if (this.props.view !== campaigns) {
            return null;
        }

        const { status } = recommendation;

        switch (recommendation.type) {
            case RecommendationType.dailyBudget:
                return (
                    <CampaignDayBudgetRecommendationCardGridPopup
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        kpi={recommendation.kpi}
                        isApplicable={recommendation.isApplicable}
                        onAcceptClick={this.onSubmitRecommendation(recommendation.type, recommendation.keys)}
                        status={status}
                        onShow={this.props.onShowRecommendation}
                    />
                );

            case RecommendationType.removePagesFromBlackList: {
                const removePagesFromBlackListPages = recommendation.items || [],
                    removePagesFromBlackListPagesMaxNumber = 3;

                return (
                    <RemovePagesFromBlackListRecommendationCardGridPopup
                        icon={getRecommendationIconByType(recommendation.type)}
                        character={recommendation.character}
                        kpi={recommendation.kpi}
                        isApplicable={recommendation.isApplicable}
                        onAcceptClick={this.onSubmitRecommendation(recommendation.type, recommendation.keys)}
                        status={status}
                        pages={removePagesFromBlackListPages.slice(0, removePagesFromBlackListPagesMaxNumber)}
                        pagesNumber={removePagesFromBlackListPages.length}
                        onShow={this.props.onShowRecommendation}
                    />
                );
            }

            default:
                return null;
        }
    };

    private onSubmitRecommendation = (type: RecommendationType, keys: Array<RecommendationKey>) => () => {
        return this.props.onSubmitRecommendation ? this.props.onSubmitRecommendation(type, keys) : undefined;
    };
}
